import React from "react";
import { GetCompliantPageWrapper } from "../../../components/layout/GetCompliantPageWrapper";
import { PageHeader } from "../../../components/layout/header/Header";
import {
  CookieScanner,
  useCookieScanner,
} from "../../../components/organisms/cookies/CookieScanner";
import { Para } from "../../../components/typography/Para";
import { Paras } from "../../../components/typography/Paras";
import { usePrimaryOrganization } from "../../../hooks";

export const DataRetentionCookieScanner: React.FC = () => {
  const [organization, orgRequest] = usePrimaryOrganization();
  const scanner = useCookieScanner();

  const regionFeatures = [
    organization.featureGdpr || !organization.featurePipeda ? "GDPR" : null,
    organization.featurePipeda ? "PIPEDA" : null,
  ]
    .filter(Boolean)
    .join(" & ");

  const instructions = (
    <Paras>
      <Para>
        This scanner is used to detect cookies and trackers on your page. You can add this as a
        cookie table to your Privacy Policy through the embeddable assets.
      </Para>
    </Paras>
  );

  return (
    <GetCompliantPageWrapper
      requests={[
        scanner.requests.cookieScanRequest,
        scanner.requests.cookieRecommendationsRequest,
        scanner.requests.organizationDataRecipientsRequest,
        scanner.requests.vendorCatalogRequest,
        orgRequest,
      ]}
    >
      <PageHeader
        titleContent="Cookie Scanner"
        titleHeaderContent={`${regionFeatures} Compliance`}
      />

      <CookieScanner {...scanner.props} instructions={instructions} />
    </GetCompliantPageWrapper>
  );
};
